const ENV = process.env.REACT_APP_MODE;
const config = {
  DEV: {
    REACT_APP_API_BASE_URL: "http://13.202.209.60:8083",
  },
  UAT: {
    REACT_APP_API_BASE_URL: "https://uat-immnuoact.hashstudioz.us",
  },
  PREPROD: {
    REACT_APP_API_BASE_URL: "http://3.110.234.56",
  },
  PROD: {
    REACT_APP_API_BASE_URL: "https://act360.in",
  },
  LOCAL: {
    REACT_APP_API_BASE_URL: "http://localhost:8083",
  },
};
export default config[ENV];